import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';

export const NavSelectBlock = styled.div`
  position: relative;
  margin: 0 15px;
  color: ${({ theme }) => theme.mainColor};

  svg {
    position: absolute;
    top: 24px;
    right: 0;
  }

  ${minMediaQueries.phablet`
    display: none;
  `};
`;

export const NavSelect = styled.select`
  position: relative;
  z-index: 1;
  width: auto;
  padding: 18px 21px 18px 0;
  cursor: pointer;
  font-family: ${({ theme }) => theme.bodyFontFamily};
  ${getFont(0)};
  font-weight: 500;
  ${fontSmoothing}
  color: ${({ theme }) => theme.mainColor};

  ::-ms-expand {
    display: none;
  }
`;
